export default "__VITE_ASSET__DBGgCqKp__"